import { computed, Injectable, signal } from '@angular/core';
import type { AppError } from '@core/error-handling/app-error.types';

@Injectable({ providedIn: 'root' })
export class AppErrorService {
  private readonly fatalErrorState = signal<AppError | null>(null);
  private readonly reportedRuntimeErrorsState = signal<readonly AppError[]>([]);

  public readonly activeFatalError = computed(() => this.fatalErrorState());
  public readonly reportedRuntimeErrors = computed(() => this.reportedRuntimeErrorsState());

  public reportFatal(error: AppError): void {
    this.reportedRuntimeErrorsState.update((current) => [...current, error]);
    this.fatalErrorState.set(error);
    console.error('Unhandled application error:', error);
  }

  public clearFatal(): void {
    this.fatalErrorState.set(null);
  }
}
